import { Company } from './company.types';
import { Stakeholder } from './stakeholder.types';

export enum VaultTab {
  OPEN_DRIVE = 'open-drive',
  REPOSITORY = 'repository',
}

export enum VaultSortBy {
  FILES = 'files',
  LAST_EDIT = 'last-edit',
  NAME = 'name',
  SIZE = 'size',
}

export enum VaultOrder {
  ASC = 'asc',
  DESC = 'desc',
}

export enum VaultSelect {
  FILE = 'file',
  FOLDER = 'folder',
}

export type VaultSelectVariant = 'add' | VaultSelect;

export type VaultFolder = {
  company?: Company;
  createdAt: string;
  fileCount: number;
  files?: VaultFile[];
  folders?: VaultFolder[];
  generatedAutomatically: boolean;
  id: string;
  name: string;
  parentFolder?: VaultFolder;
  size: number;
  stakeholder?: Stakeholder;
  updatedAt: string;
  uploadPermission: boolean;
};

export enum VaultFileSource {
  DOCUSIGN = 'docusign',
  UPLOAD = 'upload',
}

export type VaultFile = {
  company?: Company;
  createdAt: string;
  fileSource?: VaultFileSource;
  folder?: VaultFolder;
  generatedAutomatically: boolean;
  id: string;
  link: string;
  name: string;
  signatureId?: null | string;
  size: number;
  stakeholder?: Stakeholder;
  updatedAt: string;
};

export type Repository = {
  files?: VaultFile[];
  folders?: VaultFolder[];
  uploadPermission?: boolean;
};

export type CreateFileDto = {
  files: { link: string; name?: string; size?: number }[];
  folderId?: string;
};

export type CreateFolderDto = {
  name: string;
  parentFolderId?: string;
};

export type RenameFolderDto = {
  name?: string;
  parentFolderId?: string;
};

export type RenameFileDto = {
  folderId?: string;
  link?: string;
  name?: string;
};
